<template>

    <div id="site-graphs" class="row">

        <template v-if="allDatasetsAreEmpty">

            <div class="col-12 no-detailed-data">

                <p>
                    <i class="fas fa-info-circle"></i> No detailed analysis data is available for this selection.
                </p>

            </div>

        </template>

        <template v-else>

            <div v-if="!datasetsAreEmpty(wasteStreamsChartData.datasets)" class="col-12 col-lg-3">
                <analysis-chart-component
                    :chartData="wasteStreamsChartData"
                    :options="wasteStreamsChartOptions"
                ></analysis-chart-component>
            </div>

            <div v-if="!datasetsAreEmpty(materialsChartData.datasets)" class="col-12 col-lg-5">
                <analysis-chart-component
                    :chartData="materialsChartData"
                    :options="materialsChartOptions"
                ></analysis-chart-component>
            </div>

            <div v-if="!datasetsAreEmpty(chartData.datasets)" class="col-12 col-lg-4">
                <percentage-recycled-chart-component
                    :chartData="chartData"
                    :options="chartOptions"
                ></percentage-recycled-chart-component>
            </div>

        </template>

    </div>

</template>

<script>
import PercentageRecycledChartComponent from '../chart/PercentageRecycledChartComponent'
import AnalysisChartComponent from '../chart/AnalysisChartComponent'
import ChartMixin from '../../mixins/ChartMixin'

export default {
    name: 'SiteChartsComponent',
    mixins: [ChartMixin],
    components: { AnalysisChartComponent, PercentageRecycledChartComponent },

    props: {
        siteData: {
            type: Object
        }
    },

    computed: {

        chartData: function () {
            let labels = []
            let data = []

            for (let row in this.siteData.data.graph) {
                if (this.siteData.data.graph.hasOwnProperty(row)) {
                    labels.push(this.siteData.data.graph[row].month)
                    data.push(this.siteData.data.graph[row].average)
                }
            }

            return {
                labels: labels,
                datasets: [
                    {
                        borderColor: 'rgba(141, 195, 67, 1)',
                        backgroundColor: 'rgba(141, 195, 67, 0.2)',
                        data: data,
                        borderWidth: 2
                    }
                ],
            }
        },

        wasteStreamsChartData () {
            let wasteStreamsData = this.siteData.data.waste_streams_chart

            delete wasteStreamsData.divertedFromLandfill

            return this.analysisChartData(wasteStreamsData, 'value')
        },

        materialsChartData () {
            return this.analysisChartData(this.siteData.data.materials_chart, 'value')
        },

        allDatasetsAreEmpty () {
            return (this.datasetsAreEmpty(this.wasteStreamsChartData.datasets) && this.datasetsAreEmpty(this.materialsChartData.datasets) && this.datasetsAreEmpty(this.chartData.datasets))
        }

    },

    methods: {

        datasetsAreEmpty: function (datasets) {
            for (const dataset of datasets) {
                for (const value of dataset.data) {
                    if (value > 0) return false
                }
            }

            return true
        }

    }

}
</script>
